import { render, staticRenderFns } from "./EditApolicestatuPage.vue?vue&type=template&id=40ca092e&"
import script from "./EditApolicestatuPage.vue?vue&type=script&lang=js&"
export * from "./EditApolicestatuPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports